const url = /(https?:\/\/[^\s]+)/g;

const regex = {
  url,
};
export default regex;
